import Button from '@berlitz/button'
import Spacer from '@berlitz/spacer'
import MaterialCard from '@components/LPCard/MaterialCard'
import { StoreProps } from '@interfaces/StoreState'
import ActivityCard from '@layouts/LearningPath/Chapter/ActivityCard'
import Confirmation from '@layouts/LearningPath/Chapter/Confirmation'
import ContentIcon from '@layouts/LearningPath/Chapter/ContentIcon'
import ChapterDetails from '@layouts/LearningPath/Chapter/Details'
import Download from '@layouts/LearningPath/Chapter/Download'
import { isChromium } from '@utils/browser'
import React, { useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { ChapterProp } from './interface'
import { Bridge, Container, Content, Text, TileContainer, OverrideAITutorLink } from './style'
import AITutorLink from '@components/LPCard/Common/AITutorLink'

const Chapter: React.FC<ChapterProp> = ({ active, setPlayVideo, Unit, bridgeless }) => {
  const profileType = useSelector(({ userProfile }: StoreProps) => userProfile?.info?.Type)
  const [showDetails, setShowDetails] = React.useState(false)
  const [downloadSelection, setDownloadSelection] = React.useState(false)
  const [showConfirmation, setShowConfirmation] = React.useState(false)
  const filteredAttachments = Unit.getAttachments(profileType)
  const itemRef = useRef<HTMLDivElement | null>(null)
  const program = useSelector(({ activeState }: StoreProps) => activeState.learningPath?.AllPrograms)
  const status = program?.some((prog) => prog?.IsActive) ? 'unlocked' : 'locked'

  useEffect(() => {
    active &&
      itemRef?.current?.parentElement?.scrollIntoView({
        behavior: isChromium() ? 'auto' : 'smooth',
        block: 'center',
        inline: 'center',
      })
  }, [active])

  if (Unit.IsCourseMetaData) {
    return (
      <div ref={itemRef}>
        <MaterialCard
          status={Unit.Status}
          active={active}
          attachments={filteredAttachments}
          title={Unit.Title}
          Unit={Unit}
        />
      </div>
    )
  }

  return (
    <Container className="online-practice" ref={itemRef}>
      <Confirmation setShowConfirmation={setShowConfirmation} showConfirmation={showConfirmation} />
      <TileContainer active={active} status={Unit.Status}>
        {showDetails ? (
          <>
            <ChapterDetails Unit={Unit} showDetails={showDetails} />
            {!!filteredAttachments && !!filteredAttachments.length ? (
              <Download
                setDownloadSelection={setDownloadSelection}
                downloadSelection={downloadSelection}
                filteredAttachments={filteredAttachments}
              />
            ) : (
              <Spacer size="xxxl" />
            )}
          </>
        ) : (
          <Content>
            <ContentIcon Unit={Unit} setPlayVideo={setPlayVideo} />
            <Text status={Unit.Status}>{Unit.Title}</Text>
            <Spacer size="xxxs" />
            <Spacer size="xxs" />
            <ActivityCard
              Unit={Unit}
              setShowConfirmation={setShowConfirmation}
              showConfirmation={showConfirmation}
              profileType={profileType}
            />
            <OverrideAITutorLink>
              <AITutorLink
                unit={Unit}
                status={status}
                txtColor="black"
                btnColor="brandPrimary"
                isLiveOnlineProgram={program?.some((prog) => prog?.isProgramLiveOnline())}
              />
            </OverrideAITutorLink>
          </Content>
        )}

        <Button fullWidth onClick={() => setShowDetails(!showDetails)}>
          <FormattedMessage id={showDetails ? 'Close' : 'Details'} />
        </Button>
        {!bridgeless && <Bridge status={Unit.Status} />}
      </TileContainer>
    </Container>
  )
}

export default Chapter
